import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';

import { DynamicPricingExclusionConfig } from '~/components/LERE/types';

import LereService from '~/services/LereService';

import { lereDynamicPricingExclusionsQueryKeys } from './lereDynamicPricingExclusionsQueryKeys';

export function useUpsertDynamicPricingExclusion() {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: async (params: DynamicPricingExclusionConfig) => {
      await LereService.upsertDynamicPricingExclusion(params);
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: lereDynamicPricingExclusionsQueryKeys.all });
      enqueueSnackbar(`Updated exclusions for ${variables.entity_id}`, { variant: 'success' });
    },
    onError: (error: Error) => {
      enqueueSnackbar(`Failed to update exclusions: ${error.message || 'Unknown error'}`, {
        variant: 'error',
      });
    },
  });
}
